import LegalLayout, { Section } from './LegalLayout';

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Use" subtitle="Please read carefully" updated="May 2026">
      <Section heading="1. Educational purpose only">
        Ashom ("the App") is provided strictly for <strong>educational and informational
        purposes</strong>. Nothing in the App constitutes investment advice, financial advice, a
        recommendation, an offer, or a solicitation to buy or sell any security, commodity, or other
        financial instrument.
      </Section>
      <Section heading="2. No reliance">
        Market data, prices, indices, and analytics shown in the App are <strong>indicative and may be
        delayed or inaccurate</strong>. You must not rely on the App for trading or investment
        decisions. Always consult a licensed financial advisor and verify prices with an official
        source before acting.
      </Section>
      <Section heading="3. Data sources & accuracy">
        Data is aggregated from third-party sources (see the Data Sources page). We do not own,
        control, or guarantee that data and make no warranty as to its accuracy, completeness, or
        timeliness. Data may be unavailable or stale at any time.
      </Section>
      <Section heading="4. No warranty; limitation of liability">
        The App is provided "as is" without warranties of any kind. To the maximum extent permitted by
        law, we are not liable for any loss or damage arising from your use of, or reliance on, the App
        or its data.
      </Section>
      <Section heading="5. Acceptable use">
        You agree not to abuse, scrape, overload, or attempt to gain unauthorized access to the App or
        its APIs. Automated access may be rate-limited or blocked.
      </Section>
      <Section heading="6. Changes">
        We may update these terms or discontinue features at any time. Continued use of the App
        constitutes acceptance of the current terms.
      </Section>
    </LegalLayout>
  );
}
